import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {get, post} from "../../../common/network";


const ImportedMatterNotification = ({
                                        label, // Name of the file uploaded
                                        uploadStatus, // String with the class name to show the success/error message i.e., "success-message" or "error-message"
                                        isFileData,
                                        setImportDetails,
                                        setMattersData,
                                        mattersData,
                                        setUploadStatus,
                                        setIsUploading
                                    }) => {
    const [isUploaded, setIsUploaded] = useState(false);
    const [getResponse, setResponse] = useState(null);

    let initialLength = mattersData.length;
    /**
     * Upload handler function for uploading matters
     * @returns {Promise<void>}
     */
    const uploadHandler = async () => {
        setIsUploaded(true);
        if (isFileData) {
            setIsUploading(true);
            startGetInterval();
            const fetchData = async () => {
                try {
                    const response = await post(`docgen/import/matters`, isFileData, {
                        headers: {
                            "Content-Type": "multipart/form-data" // Set appropriate headers for form-data
                        }
                    });

                    setResponse(response.data);
                    if (response?.success === true) {
                        toast.success(response.message);
                        setImportDetails(null);
                        setUploadStatus(null);
                    }
                } catch (error) {
                } finally {
                    setIsUploaded(false);
                    setIsUploading(false);
                }
            };
            await fetchData();
        }
    };

    const onCancel = () => {
        setImportDetails(null);
        setUploadStatus(null);
    };

    useEffect(() => {
        fetchImportedData();
    }, [getResponse]);

    const fetchImportedData = async () => {
        try {
            const response = await get(`docgen/import/matters?page=1&pageSize=100&sort=updated_at:desc`);
            setMattersData(response.data);
            return response.data;
        } catch (error) {
        }
    };

    const startGetInterval = () => {
        let getInterval;
        getInterval = setInterval(async () => {
            try {
                const importedData = await fetchImportedData();
                if (initialLength !== importedData.length && importedData[0]?.status === "Completed") {
                    clearInterval(getInterval);
                }
            } catch (error) {

            }
        }, 10000);
    };

    return (
        <Paper
            sx={{mb: "15px", p: "20px"}}
            elevation={0}
            className={`message-status ${uploadStatus}`}
        >
            <Chip
                sx={{
                    borderRadius: "5px",
                    border: "1px solid #D9D9D9",
                    width: "100%",
                    textAlign: "left",
                    justifyContent: "flex-start",
                    backgroundColor: "#F3F3F3"
                }}
                icon={
                    <AttachFileOutlinedIcon
                        sx={{
                            fontSize: "20px"
                        }}
                    />
                }
                deleteIcon={
                    <HighlightOffOutlinedIcon
                        sx={{
                            ml: "auto !important",
                            display: "inline-block",
                            fill: "#999"
                        }}
                    />
                }
                label={label}
                onDelete={onCancel}
            />
            {uploadStatus === "success-message" && (<small className="message-text">File is Ready to Upload</small>)}
            {uploadStatus === "error-message" && (<small className="message-text">Error!</small>)}
            <Button
                type="button"
                sx={{width: "100%", maxWidth: "200px", mt: "20px"}}
                className="btn-theme d-block ms-auto"
                onClick={() => {
                    uploadHandler();
                }}
            >
                {isUploaded ? "Uploading" : "Upload"}
            </Button>
        </Paper>
    );
};

export default ImportedMatterNotification;